import { battery, firmwareName, lastSeen } from '~/helpers/fields-description';
import { Const } from '../../../constants/Const.constant';
import { NAModule } from '../NAModule.model';

export class NTE extends NAModule {
    hasOperationDissociate = false;

    battery_levels = {
        full: Const.NABatteryLevelNTEModule.UPPER_BOUND,
        high: Const.NABatteryLevelNTEModule.NTE_BATTERY_LEVEL_0,
        medium: Const.NABatteryLevelNTEModule.NTE_BATTERY_LEVEL_1,
        low: Const.NABatteryLevelNTEModule.NTE_BATTERY_LEVEL_2,
    };

    isWired = false;
    firmware_name?: string;

    get fieldBattery() {
        return battery(this.getBatteryIcon(this.battery_vp), this.battery_vp);
    }

    get fieldFirmwareName() {
        return firmwareName(this.firmware_name);
    }

    get fieldLastSeen() {
        return lastSeen(
            this.last_seen,
            this.outdatedLastSeen ? 'error--text' : '',
        );
    }
}
